var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBallotCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 10.375H3.5a.45.45 0 0 0-.438.438v.874c0 .247.192.438.438.438h.875a.45.45 0 0 0 .438-.438v-.874a.47.47 0 0 0-.438-.438zM3.5 5.125h.875a.45.45 0 0 0 .438-.438v-.875a.47.47 0 0 0-.438-.437H3.5a.45.45 0 0 0-.438.438v.874c0 .247.192.438.438.438zm6.781 5.469H6.344c-.383 0-.657.3-.657.656 0 .383.274.656.657.656h3.937a.648.648 0 0 0 .656-.656c0-.355-.3-.656-.656-.656zm-4.73-3.801a.463.463 0 0 0-.63 0l-.984 1.012-.355-.356a.463.463 0 0 0-.629 0 .463.463 0 0 0 0 .63l.656.655c.082.082.192.11.329.11.109 0 .218-.028.3-.11l1.313-1.312a.463.463 0 0 0 0-.629zm4.73.3H7.22c-.383 0-.657.302-.657.657 0 .383.274.656.657.656h3.062a.648.648 0 0 0 .656-.656c0-.355-.3-.656-.656-.656zM11.375.75h-8.75c-.984 0-1.75.793-1.75 1.75V13c0 .984.766 1.75 1.75 1.75h8.75c.957 0 1.75-.766 1.75-1.75V2.5c0-.957-.793-1.75-1.75-1.75zM11.813 13a.45.45 0 0 1-.438.438h-8.75A.432.432 0 0 1 2.187 13V2.5a.45.45 0 0 1 .438-.438h8.75a.47.47 0 0 1 .438.438V13zM10.28 3.594H6.344c-.383 0-.657.3-.657.656 0 .383.274.656.657.656h3.937a.648.648 0 0 0 .656-.656c0-.355-.3-.656-.656-.656z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallotCheck);
export default __webpack_public_path__ + "static/media/ballot-check.4ddbad0244c9bfcf1266b496d75657ef.svg";
export { ForwardRef as ReactComponent };